/** Matches login / form labels elsewhere (`text-sm font-medium leading-6 text-gray-900`). */
export const GUEST_FIELD_LABEL_CLASS = "block text-sm font-medium leading-6 text-gray-900";

export function guestProviderRecordId(u) {
  return u?.provider_id;
}

/** Stable id for location list rows and API `location_id` (payloads vary). */
export function guestLocationId(loc) {
  if (!loc || typeof loc !== "object") return "";
  return loc.location_key;
}
